import { render, staticRenderFns } from "./BdrNestedRecords.vue?vue&type=template&id=03966d86&"
import script from "./BdrNestedRecords.vue?vue&type=script&lang=js&"
export * from "./BdrNestedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports